//Use this class as a model for future services.
//No Custom Repository Class is required 

import { SearchInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';
import { SearchInput } from '../entities/input/searchInput';

@autoinject()

export class SearchInfoService {

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(SearchInfo);
	}

	search(searchInput:SearchInput) {
		return this.repository.find(searchInput);
	}

}